import type { DragEvent } from 'react';

import { LECTURE_DRAG_TYPE } from './LectureLibraryTree';

export interface LectureDropZoneProps {
  label: string;
  onDrop: () => void;
}

// PO addition, not in Figma - a dashed ring over the canvas while a lesson row is being dragged
export function LectureDropZone({ label, onDrop }: LectureDropZoneProps) {
  function accept(event: DragEvent<HTMLDivElement>) {
    if (event.dataTransfer.types.indexOf(LECTURE_DRAG_TYPE) < 0) return;
    event.preventDefault();
    event.dataTransfer.dropEffect = 'copy';
  }

  return (
    <div className="lib-dropzone" aria-hidden={true} onDragEnter={accept} onDragOver={accept} onDrop={(event) => { event.preventDefault(); onDrop(); }}>
      <div className="lib-dropzone__ring"><span>Thả để mở {label}</span></div>
    </div>
  );
}
